// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"318":"d4c5fa22","787":"e7025f93"}[chunkId] + ".chunk.js";
};